import contentChangeActionFactory from '../actions/factories/contentChangeActionFactory';
import formActionCreators from '../actions/formActionCreators';
import store from '../reducers/storeRegistration';
const contentChangeActions = contentChangeActionFactory('cabinet', 'forms');

/**
 *  Reload the open form from the server and refresh its cabinet row, to show changes made
 *  by server-side work (e.g. a queued import's progress). Unsaved edits are discarded, so
 *  callers save first or only offer this where the form has none.
 */
export const evaluate = async (entity, entityName, source, content) => {
  await store.dispatch(contentChangeActions.saveSuccess(content.id, content));
  return store.dispatch(formActionCreators.serverShow(content.id));
};
export default {
  evaluate
};